import React from 'react';

export default function OCmsFooter() {
	return (
		<footer className="o-footer-cms" />
	);
}




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.cms-footer.js